import { Component, OnInit, Input, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MbAccelerator, MbIcon } from '@am/moebius';

const DEFAULT_HIDE_DELAY = 5000;
@Component({
    selector: 'users-views',
    templateUrl: './users-views.component.html',
    styleUrls: ['./users-views.component.scss'],
    standalone: true,
    imports: [MbAccelerator, MbIcon],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UsersViewsComponent implements OnInit {
  @Input()
  nameHotel: string;
  @Input()
  usersViews: number;
  @Input()
  hideDelay: number;
  @ViewChild('accelerator', { static: true }) accelerator: MbAccelerator;

  constructor() {}

  ngOnInit() {
    this.openAccelerator();
  }

  private openAccelerator() {
    if (!this.accelerator.isVisible()) {
      this.accelerator.show();
      setTimeout(() => {
        this.accelerator.hide();
      }, this.hideDelay || DEFAULT_HIDE_DELAY);
    }
  }
}
